export default __webpack_public_path__ + "dffae17524847ef31d0116d6ff0d9a9b.ttf";